import React, { useEffect, useMemo, useState } from "react";
import FeatureNewsModal from "./FeatureNewsModal";
import {
  listPublishedFeatureNews,
  subscribeFeatureNewsChanged,
} from "./featureNewsApi";
import {
  dismissFeatureNews,
  getFeatureNewsDismissKey,
  getUnreadFeatureNews,
  isFeatureNewsEnabled,
} from "./featureNewsStorage";

export default function FeatureNewsHost({ userId, token }) {
  const enabled = isFeatureNewsEnabled();
  const [catalog, setCatalog] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!enabled || !userId || !token) {
      return undefined;
    }

    let cancelled = false;
    const load = (isInitial) => {
      listPublishedFeatureNews(token)
        .then((items) => {
          if (cancelled) {
            return;
          }
          const published = (items || []).filter((item) => item?.isActive !== false);
          setCatalog(published);
          if (isInitial && getUnreadFeatureNews(userId, published).length > 0) {
            setOpen(true);
          }
        })
        .catch(() => {
          if (!cancelled) {
            setCatalog([]);
          }
        });
    };

    const schedule = window.requestIdleCallback || ((callback) => setTimeout(callback, 0));
    const cancelSchedule = window.cancelIdleCallback || clearTimeout;
    const scheduleId = schedule(() => {
      if (!cancelled) {
        load(true);
      }
    });
    const unsubscribe = subscribeFeatureNewsChanged(() => load(false));
    return () => {
      cancelled = true;
      cancelSchedule(scheduleId);
      unsubscribe();
    };
  }, [enabled, userId, token]);

  const unread = useMemo(
    () => (enabled && userId ? getUnreadFeatureNews(userId, catalog) : []),
    [enabled, userId, catalog]
  );

  if (!enabled || !userId || unread.length === 0) {
    return null;
  }

  const handleDismiss = () => {
    dismissFeatureNews(
      userId,
      unread.map((item) => getFeatureNewsDismissKey(item))
    );
    setOpen(false);
  };

  return (
    <FeatureNewsModal open={open} items={unread} onDismiss={handleDismiss} />
  );
}
